// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import Analytics__CalendarDrawerController from "./analytics/calendar_drawer_controller"
application.register("analytics--calendar-drawer", Analytics__CalendarDrawerController)

import Analytics__EventController from "./analytics/event_controller"
application.register("analytics--event", Analytics__EventController)

import Analytics__PresentController from "./analytics/present_controller"
application.register("analytics--present", Analytics__PresentController)

import Analytics__PreviewController from "./analytics/preview_controller"
application.register("analytics--preview", Analytics__PreviewController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AnimateController from "./animate_controller"
application.register("animate", AnimateController)

import AriaController from "./aria_controller"
application.register("aria", AriaController)

import ArrayInputController from "./array_input_controller"
application.register("array-input", ArrayInputController)

import AttendanceController from "./attendance_controller"
application.register("attendance", AttendanceController)

import AttendanceRefreshController from "./attendance_refresh_controller"
application.register("attendance-refresh", AttendanceRefreshController)

import AutoRedirectController from "./auto_redirect_controller"
application.register("auto-redirect", AutoRedirectController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AvatarBuilderController from "./avatar_builder_controller"
application.register("avatar-builder", AvatarBuilderController)

import AvatarRemoteController from "./avatar_remote_controller"
application.register("avatar-remote", AvatarRemoteController)

import BentoController from "./bento_controller"
application.register("bento", BentoController)

import BubbleGridController from "./bubble_grid_controller"
application.register("bubble-grid", BubbleGridController)

import BuildAnswersController from "./build_answers_controller"
application.register("build-answers", BuildAnswersController)

import BuildBriefsController from "./build_briefs_controller"
application.register("build-briefs", BuildBriefsController)

import BuildOverflowController from "./build_overflow_controller"
application.register("build-overflow", BuildOverflowController)

import BuildOverlayController from "./build_overlay_controller"
application.register("build-overlay", BuildOverlayController)

import BuildPollController from "./build_poll_controller"
application.register("build-poll", BuildPollController)

import BuildRowsController from "./build_rows_controller"
application.register("build-rows", BuildRowsController)
application.register("build-options", BuildRowsController)

import BurgerController from "./burger_controller"
application.register("burger", BurgerController)

import Calendar__DragController from "./calendar/drag_controller"
application.register("calendar--drag", Calendar__DragController)

import Calendar__EventActionsController from "./calendar/event_actions_controller"
application.register("calendar--event-actions", Calendar__EventActionsController)

import Calendar__ExtendedHoverController from "./calendar/extended_hover_controller"
application.register("calendar--extended-hover", Calendar__ExtendedHoverController)

import Calendar__MenuLoaderController from "./calendar/menu_loader_controller"
application.register("calendar--menu-loader", Calendar__MenuLoaderController)

import Calendar__NavigationController from "./calendar/navigation_controller"
application.register("calendar--navigation", Calendar__NavigationController)

import Calendar__PopoverDragController from "./calendar/popover_drag_controller"
application.register("calendar--popover-drag", Calendar__PopoverDragController)

import CaretAtEndController from "./caret_at_end_controller"
application.register("caret-at-end", CaretAtEndController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import Chart__HighlightController from "./chart/highlight_controller"
application.register("chart--highlight", Chart__HighlightController)

import Chart__LegendController from "./chart/legend_controller"
application.register("chart--legend", Chart__LegendController)

import Chart__LineHoverController from "./chart/line_hover_controller"
application.register("chart--line-hover", Chart__LineHoverController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckInDotsController from "./check_in_dots_controller"
application.register("check-in-dots", CheckInDotsController)

import CheckboxesController from "./checkboxes_controller"
application.register("checkboxes", CheckboxesController)

import ClickController from "./click_controller"
application.register("click", ClickController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CoachCalloutController from "./coach_callout_controller"
application.register("coach-callout", CoachCalloutController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ConditionalRenderController from "./conditional_render_controller"
application.register("conditional-render", ConditionalRenderController)

import ConfirmDestroyController from "./confirm_destroy_controller"
application.register("confirm-destroy", ConfirmDestroyController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CurriculumGuideController from "./curriculum_guide_controller"
application.register("curriculum-guide", CurriculumGuideController)


import CurriculumSectionsController from "./curriculum_sections_controller"
application.register("curriculum-sections", CurriculumSectionsController)

import DatePlaceholderController from "./date_placeholder_controller"
application.register("date-placeholder", DatePlaceholderController)

import DisableUntilSelectedController from "./disable_until_selected_controller"
application.register("disable-until-selected", DisableUntilSelectedController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DomSearchController from "./dom_search_controller"
application.register("dom-search", DomSearchController)

import DrawerStepsController from "./drawer_steps_controller"
application.register("drawer-steps", DrawerStepsController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import EitherOrController from "./either_or_controller"
application.register("either-or", EitherOrController)

import EmbedController from "./embed_controller"
application.register("embed", EmbedController)

import EnableController from "./enable_controller"
application.register("enable", EnableController)

import FeedbacksController from "./feedbacks_controller"
application.register("feedbacks", FeedbacksController)

import FilepondController from "./filepond_controller"
application.register("filepond", FilepondController)

import FilterBarController from "./filter_bar_controller"
application.register("filter-bar", FilterBarController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FinalSlideController from "./final_slide_controller"
application.register("final-slide", FinalSlideController)

import FontSizeController from "./font_size_controller"
application.register("font-size", FontSizeController)

import FormChangesController from "./form_changes_controller"
application.register("form-changes", FormChangesController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormResetController from "./form_reset_controller"
application.register("form-reset", FormResetController)

import FrameFallbackController from "./frame_fallback_controller"
application.register("frame-fallback", FrameFallbackController)

import GtmController from "./gtm_controller"
application.register("gtm", GtmController)

import HoverPreviewController from "./hover_preview_controller"
application.register("hover-preview", HoverPreviewController)

import HtmlAttributesController from "./html_attributes_controller"
application.register("html-attributes", HtmlAttributesController)

import HubspotChatController from "./hubspot_chat_controller"
application.register("hubspot-chat", HubspotChatController)

import IframeController from "./iframe_controller"
application.register("iframe", IframeController)

import RelayKeyController from "./relay_key_controller"
application.register("relay-key", RelayKeyController)

import InjectHtmlController from "./inject_html_controller"
application.register("inject-html", InjectHtmlController)

import InputCodeController from "./input_code_controller"
application.register("input-code", InputCodeController)

import JoinClassesController from "./join_classes_controller"
application.register("join-classes", JoinClassesController)

import JsonEditorController from "./json_editor_controller"
application.register("json-editor", JsonEditorController)

import PlaceholderCycleController from "./placeholder_cycle_controller"
application.register("placeholder-cycle", PlaceholderCycleController)

import LibrarySearchController from "./library_search_controller"
application.register("library-search", LibrarySearchController)

import InputSearchController from "./input_search_controller"
application.register("input-search", InputSearchController)

import KeyboardFocusController from "./keyboard_focus_controller"
application.register("keyboard-focus", KeyboardFocusController)

import LibraryTabController from "./library_tab_controller"
application.register("library-tab", LibraryTabController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import LockRefreshController from "./lock_refresh_controller"
application.register("lock-refresh", LockRefreshController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultipleSearchController from "./multiple_search_controller"
application.register("multiple-search", MultipleSearchController)

import NavigateController from "./navigate_controller"
application.register("navigate", NavigateController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NestedSortableController from "./nested_sortable_controller"
application.register("nested-sortable", NestedSortableController)

import NudgeController from "./nudge_controller"
application.register("nudge", NudgeController)

import OrderedSelectsController from "./ordered_selects_controller"
application.register("ordered-selects", OrderedSelectsController)

import PasswordHintController from "./password_hint_controller"
application.register("password-hint", PasswordHintController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PictureChoiceController from "./picture_choice_controller"
application.register("picture-choice", PictureChoiceController)
import PriorityLoaderController from "./priority_loader_controller"
application.register("priority-loader", PriorityLoaderController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import PresentationControlsController from "./presentation_controls_controller"
application.register("presentation-controls", PresentationControlsController)

import ProgressTrackerController from "./progress_tracker_controller"
application.register("progress-tracker", ProgressTrackerController)

import PromptDismissalController from "./prompt_dismissal_controller"
application.register("prompt-dismissal", PromptDismissalController)

import QuestionSubmitGateController from "./question_submit_gate_controller"
application.register("question-submit-gate", QuestionSubmitGateController)

import RadioBackgroundController from "./radio_background_controller"
application.register("radio-background", RadioBackgroundController)

import RailsNestedFormController from "./rails_nested_form_controller"
application.register("rails-nested-form", RailsNestedFormController)

import RankedSelectionController from "./ranked_selection_controller"
application.register("ranked-selection", RankedSelectionController)

import RefreshKeepsModalController from "./refresh_keeps_modal_controller"
application.register("refresh-keeps-modal", RefreshKeepsModalController)

import RememberSelectController from "./remember_select_controller"
application.register("remember-select", RememberSelectController)

import RemoveElementController from "./remove_element_controller"
application.register("remove-element", RemoveElementController)

import RemoveShortcutController from "./remove_shortcut_controller"
application.register("remove-shortcut", RemoveShortcutController)

import RenderTemplateController from "./render_template_controller"
application.register("render-template", RenderTemplateController)

import RequestController from "./request_controller"
application.register("request", RequestController)

import RequiredFieldsSubmitController from "./required_fields_submit_controller"
application.register("required-fields-submit", RequiredFieldsSubmitController)

import ResendCountdownController from "./resend_countdown_controller"
application.register("resend-countdown", ResendCountdownController)

import RespondentVotesController from "./respondent_votes_controller"
application.register("respondent-votes", RespondentVotesController)

import ResponseBrowserController from "./response_browser_controller"
application.register("response-browser", ResponseBrowserController)

import ResponseLengthIndicatorController from "./response_length_indicator_controller"
application.register("response-length-indicator", ResponseLengthIndicatorController)

import ResumeRefreshController from "./resume_refresh_controller"
application.register("resume-refresh", ResumeRefreshController)

import RevealQuestionsController from "./reveal_questions_controller"
application.register("reveal-questions", RevealQuestionsController)

import RulesBuilderController from "./rules_builder_controller"
application.register("rules-builder", RulesBuilderController)

import ScrollOverflowController from "./scroll_overflow_controller"
application.register("scroll-overflow", ScrollOverflowController)

import ScrollbarController from "./scrollbar_controller"
application.register("scrollbar", ScrollbarController)

import SelectFormController from "./select_form_controller"
application.register("select-form", SelectFormController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import SectionSlideController from "./section_slide_controller"
application.register("section-slide", SectionSlideController)

import LegacySectionSlideController from "./legacy_section_slide_controller"
application.register("legacy-section-slide", LegacySectionSlideController)

import SelectFocusController from "./select_focus_controller"
application.register("select-focus", SelectFocusController)

import SelectionCountController from "./selection_count_controller"
application.register("selection-count", SelectionCountController)

import SigningInController from "./signing_in_controller"
application.register("signing-in", SigningInController)

import SlideCarouselController from "./slide_carousel_controller"
application.register("slide-carousel", SlideCarouselController)

import SlidesController from "./slides_controller"
application.register("slides", SlidesController)

import SlidesEditorController from "./slides_editor_controller"
application.register("slides-editor", SlidesEditorController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableQuestionController from "./sortable_question_controller"
application.register("sortable-question", SortableQuestionController)

import SparksController from "./sparks_controller"
application.register("sparks", SparksController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import StudentProfileFormController from "./student_profile_form_controller"
application.register("student-profile-form", StudentProfileFormController)

import Table__ColumnVisibilityController from "./table/column_visibility_controller"
application.register("table--column-visibility", Table__ColumnVisibilityController)

import Table__SortController from "./table/sort_controller"
application.register("table--sort", Table__SortController)

import TeachingPromptController from "./teaching_prompt_controller"
application.register("teaching-prompt", TeachingPromptController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import TippyHideController from "./tippy_hide_controller"
application.register("tippy-hide", TippyHideController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleTabsController from "./toggle_tabs_controller"
application.register("toggle-tabs", ToggleTabsController)

import ToolBarController from "./tool_bar_controller"
application.register("tool-bar", ToolBarController)

import TranslationProofreaderController from "./translation_proofreader_controller"
application.register("translation-proofreader", TranslationProofreaderController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import TrixLimitController from "./trix_limit_controller"
application.register("trix-limit", TrixLimitController)

import UnpublishedExitController from "./unpublished_exit_controller"
application.register("unpublished-exit", UnpublishedExitController)

import UnsavedProgressController from "./unsaved_progress_controller"
application.register("unsaved-progress", UnsavedProgressController)

import UploadPreviewController from "./upload_preview_controller"
application.register("upload-preview", UploadPreviewController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import WizardLockController from "./wizard_lock_controller"
application.register("wizard-lock", WizardLockController)

import YoutubeController from "./youtube_controller"
application.register("youtube", YoutubeController)
